import type { CompanyStrengthItem } from '../types';
import { DynamicIcon } from './CommonComponents';
import { usePreviewTheme, withAlpha } from './PreviewTheme';

interface CompanyStrengthSectionProps {
  items: CompanyStrengthItem[];
}

export default function CompanyStrengthSection({ items }: CompanyStrengthSectionProps) {
  const theme = usePreviewTheme();

  if (!items || items.length === 0) {
    return null;
  }

  return (
    <div>
      {/* 标题区域 */}
      <div className="px-4 py-3 border-b border-gray-100 flex items-center">
        <div className="flex items-center gap-2">
          <h3 className="text-base font-bold" style={{ color: theme.textHighlightColor }}>核心实力</h3>
          <p className="text-xs text-gray-400 tracking-widest ml-1">CORE STRENGTH</p>
        </div>
      </div>

      {/* 实力列表 */}
      <div className="px-4 pb-4 mt-4 space-y-2">
        {items.map((item, idx) => (
          <div
            key={item.id}
            className="flex items-start gap-3 rounded-xl p-3"
            style={{
              background: item.iconBgColor
                ? `linear-gradient(135deg, ${item.iconBgColor}10 0%, #ffffff 100%)`
                : `linear-gradient(135deg, ${withAlpha(theme.themeColor, '0D')} 0%, #ffffff 100%)`,
              border: `1px solid ${item.iconBgColor ? item.iconBgColor + '30' : withAlpha(theme.themeColor, '26')}`,
            }}
          >
            {/* 图标 */}
            <div
              className="shrink-0 w-11 h-11 rounded-full flex items-center justify-center shadow-sm"
              style={{
                background: item.iconBgColor
                  ? `linear-gradient(135deg, ${item.iconBgColor}20, ${item.iconBgColor}10)`
                  : `linear-gradient(135deg, ${withAlpha(theme.themeColor, '0D')}, #ffffff)`,
              }}
            >
              <span style={{ color: item.iconBgColor || theme.themeColor }}>
                <DynamicIcon
                  iconName={item.icon}
                  className="w-6 h-6"
                />
              </span>
            </div>

            {/* 内容 */}
            <div className="flex-1 min-w-0">
              {item.title && (
                <h4 className="text-sm font-semibold text-gray-800 mb-1">
                  {item.title}
                </h4>
              )}
              {item.description && (
                <div
                  className="text-xs text-gray-600 leading-relaxed rich-text-preview"
                  dangerouslySetInnerHTML={{ __html: item.description }}
                />
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
